import React from "react";
import { Link } from "react-router-dom";

export const agentPaymentHistoryColumns = (handleEdit, handleDelete, PAGE_SIZE) => [
  {
    label: "S.No.",
    width: 100,
    render: (row, index) => <span>{index + 1}</span>,
  },

  {
    label: "Agent",
    key: "name",
    width: 250,
    sortable: true,
    render: (row) => (
      <div className="userdet">
        <div>
          <i className="far fa-user" /> {row.agentId.name || "-"}
        </div>
        
        <div>
          <a href={`/admin/agent/view/${row.agentId._id}`}>#{row.agentId.agentID}</a>
        </div>
      </div>
    ),
  },

  {
    label: "Admin(Staff)",
    width: 120,
    render: (row) => <span> {row?.staffId?.name || '-'}</span>,
  },

  {
    label: "Date",
    width: 120,
    render: (row) => (
      <>
      
        <span>
          {row?.createdAt
                ? new Date(row.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
    </span>
        
      </>
    ),
  },

  {
    label: "Total Commission",
    width: 140,
    render: (row) => (<span>₹ {parseFloat(row.totalCommissionBeforePayment || 0).toFixed(2)}</span>
    ),
  },

  {
    label: "Paid Commission",
    width: 100,
    render: (row) => (
      <span>₹ {parseFloat(row.paymentAmount || 0).toFixed(2)}</span>
    ),
  },

  {
    label: "Remarks",
    width: 120,
    render: (row) => (
      <span>{row.remarks || '-'}</span>
        ),
  },
];
